function getCookie(cookieName) {
    var cookieMatch = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
    if (cookieMatch) return cookieMatch[2];
}

function createCookie(name, value, domain, samesite) {
    document.cookie = name + '=' + value + '; path=/;' + domain + samesite;
}

(function () {
    const cartCookie = getCookie('cart');
    const transferCookie = getCookie('cart_transfer');

    const stage = window.location.hostname.indexOf('stage');
    const cart = window.location.pathname.indexOf('/cart');
    const checkoutDone = window.location.href.indexOf('thank_you');

    const lang = document.documentElement.lang;
    const langPrefix = lang === 'en-DE' ? 'de' : lang.split('-')[0];

    const cookieDomain = `domain=${stage > -1 ? '.stage.burnhard.com' : '.burnhard.com'};`;
    const cartApi =
        stage > -1 ? 'https://stage.burnsoft.de/api/shop/cart' : 'https://burnsoft.de/api/shop/cart';

    if (!transferCookie && !cartCookie) {
        (async () => {
            const response = await fetch(cartApi, { method: 'POST' });
            const data = await response.json();

            createCookie('cart', data.id);
            createCookie('cart_transfer', langPrefix + ':' + data.id, cookieDomain);
        })();
    } else if (!transferCookie && cartCookie) {
        createCookie('cart_transfer', langPrefix + ':' + cartCookie, cookieDomain);
    } else if (transferCookie && !cartCookie) {
        const cartValue = transferCookie.replace('%3A', ':').split(':').at(-1);

        createCookie('cart', cartValue);

        if (cart > -1) {
            window.location.reload();
        }
    } else if (transferCookie && cartCookie) {
        const transferLang = transferCookie.split(':')[0];
        if (transferLang !== langPrefix) {
            createCookie('cart_transfer', langPrefix + ':' + cartCookie, cookieDomain);
        }
    }

    if (transferCookie && checkoutDone > -1) {
        document.cookie =
            'cart_transfer=0; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;' + cookieDomain;
    }
})();